import React, { useState } from "react";
import SimpleButton from "../simple-button/SimpleButton";
import { images } from "../../../assets/images";
import { ClipboardButtonProps, ModalInfo } from "./clipboard-button-dto";
import InfoModal from "../../info-modal";
import { MODAL_MESSAGES } from "../../../constants/modalMessages";

const defaultCleanModal = {
  showInfoModal: false,
  mainText: "",
  img: "",
};

const ClipboardButton = ({ text }: ClipboardButtonProps) => {
  const [modalInfo, setModalInfo] = useState<ModalInfo>(defaultCleanModal);

  const showModal = (mainText: string, isError: boolean): void => {
    setModalInfo({
      showInfoModal: true,
      mainText,
      img: isError ? images.IconAlertRed : images.IconCheckGreen,
    });
  };

  const copyToClipboard = async () => {
    // Older TS needs more explicit null checks
    if (!text || text.trim() === "") {
      showModal(MODAL_MESSAGES.NO_TEXT_TO_COPY, true);
      return;
    }

    if (!navigator.clipboard) {
      showModal(MODAL_MESSAGES.CLIPBOARD_API_UNAVAILABLE, true);
      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      showModal(MODAL_MESSAGES.URL_COPY_SUCCESS, false);
    } catch (err) {
      showModal(MODAL_MESSAGES.URL_COPY_ERROR, true);
    }
  };

  return (
    <>
      <SimpleButton
        text="Copiar"
        icon={images.IconCopy}
        alt="Copiar texto al portapapeles"
        onClick={copyToClipboard}
      />
      {modalInfo.showInfoModal && (
        <InfoModal
          mainText={modalInfo.mainText}
          close={() => setModalInfo(defaultCleanModal)}
          active={true}
          img={modalInfo.img}
        />
      )}
    </>
  );
};

export default ClipboardButton;
